import { useEffect } from 'react'

import { useLocation } from '@tanstack/react-router'

import { usePostHog } from '@posthog/react'

/**
 * Render-null component that fires a PostHog `$pageview` on every route location
 * change. Guarded by `posthog.__loaded` so it never captures before the SDK has
 * initialized.
 */
export default function PostHogPageView() {
	const location = useLocation()

	const posthog = usePostHog()

	// Track pageviews
	useEffect(() => {
		if (posthog.__loaded) {
			posthog.capture('$pageview', {
				$current_url: location.href,
			})
		}
	}, [location, posthog])

	return null
}
